export default {
  primaryColor: '#318EB8',
  backgroundColor: '#fff',
  red: '#ff0000',
  green: 'green',
  orange: 'orange',
};
